export const theads = [
  'Photo',
  'Status',
  'Make',
  'Model',
  'Trim/Type',
  'Model Year',
  'VIN',
  'Registration',
  'ODO',
  'Exterior Colour',
  'Interior Colour',
  'Engine CC',
  'Gears',
  'Accleration',
  'Assessment Type',
  'Body Type',
  'COD',
  'Condition',
  'Cylinders',
  'Doors',
  'Drive Type',
  'Engine Type',
  'Estimara',
  'Estimara expiry date',
  'Finance Status',
  'Fuel Type',
  'HP (Horse Power)',
  'Last service date',
  'MVPI expiry date',
  'Max Speed',
  'Mileage',
  'Origin',
  'Seat',
  'Service and maintenance status',
  'Torque',
  'Transmission Type',
  'Upholstery',
  'Utility Type',
  'Vehicle Type',
  'Vendor',
  'Warranty',
  'Warranty expiry date',
  'Wheel Base',
  'View',
];

export const columns = [
  {
    title: 'Photo',
    data: 'Photo',
    render: (data) => {
      return `<img src="${data}" style="width: 6rem; height: auto;"/>`;
    },
  },
  {
    title: 'Status',
    data: 'Status',
    render: (data) => {
      return `${
        data === 'Active'
          ? `<div class="d-flex">
              <span style="color: green; font-size: 18px" class="mr-1">●</span>
              Active
            </div>`
          : `<div class="d-flex mr-1">
              <span style="color: red; font-size: 18px" class="mr-1">●</span>
              Inactive
            </div>`
      }`;
    },
  },
  { title: 'Make', data: 'Make' },
  { title: 'Model', data: 'Model' },
  { title: 'Trim/Type', data: 'Trim/Type' },
  { title: 'Model Year', data: 'Model Year' },
  { title: 'VIN', data: 'VIN' },
  { title: 'Registration', data: 'Registration' },
  { title: 'ODO', data: 'ODO' },
  { title: 'Exterior Colour', data: 'Exterior Colour' },
  { title: 'Interior Colour', data: 'Interior Colour' },
  { title: 'Engine CC', data: 'Engine CC' },
  { title: 'Gears', data: 'Gears' },
  { title: 'Accleration', data: 'Accleration' },
  { title: 'Assessment Type', data: 'Assessment Type' },
  { title: 'Body Type', data: 'Body Type' },
  { title: 'COD', data: 'COD' },
  { title: 'Condition', data: 'Condition' },
  { title: 'Cylinders', data: 'Cylinders' },
  { title: 'Doors', data: 'Doors' },
  { title: 'Drive Type', data: 'Drive Type' },
  { title: 'Engine Type', data: 'Engine Type' },
  { title: 'Estimara', data: 'Estimara' },
  { title: 'Estimara expiry date', data: 'Estimara expiry date' },
  { title: 'Finance Status', data: 'Finance Status' },
  { title: 'Fuel Type', data: 'Fuel Type' },
  { title: 'HP (Horse Power)', data: 'HP (Horse Power)' },
  { title: 'Last service date', data: 'Last service date' },
  { title: 'MVPI expiry date', data: 'MVPI expiry date' },
  { title: 'Max Speed', data: 'Max Speed' },
  { title: 'Mileage', data: 'Mileage' },
  { title: 'Origin', data: 'Origin' },
  { title: 'Seat', data: 'Seat' },
  {
    title: 'Service and maintenance status',
    data: 'Service and maintenance status',
  },
  { title: 'Torque', data: 'Torque' },
  { title: 'Transmission Type', data: 'Transmission Type' },
  { title: 'Upholstery', data: 'Upholstery' },
  { title: 'Utility Type', data: 'Utility Type' },
  { title: 'Vehicle Type', data: 'Vehicle Type' },
  { title: 'Vendor', data: 'Vendor' },
  { title: 'Warranty', data: 'Warranty' },
  { title: 'Warranty expiry date', data: 'Warranty expiry date' },
  { title: 'Wheel Base', data: 'Wheel Base' },
  {
    title: 'View',
    data: 'View',
    render: (data, type, row) => {
      return `<button type="button" class="btn btn__util view-btn" data-product-id="${data}">
      <ion-icon name="eye" class="ion-lg color-yellow"></ion-icon>
    </button>`;
    },
  },
];

export const commonDtOptions = {
  pagingType: 'simple_numbers',
  serverSide: true,
  processing: true,
  buttons: ['csv', 'print', 'excel'],
  dom: 'Blfrtip',
  ordering: false,
  columns: columns,
  lengthChange: true,
  scrollX: true,
  pageLength: 10,
  language: {
    processing:
      '<div class="custom-loader"><div class="spinner"></div><div class="loading-text">Loading data ...</div></div>',
  },
  lengthMenu: [
    10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 120, 140, 160, 180, 200, 240, 280,
    300, 400, 500,
  ],
  fixedColumns: {
    left: 4,
    right: 1,
  },
  searching: false,
};
